<template>
  <div class="setComponent">
    <!-- 提示栏 -->
    <el-alert
      style="margin:15px 0;"
      :title="$i18n.t('wm_lang_cb6d41')"
      :closable="false"
      type="info">
    </el-alert>
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" @submit.native.prevent ref="ruleForm" label-width="0" class="form-setting" size="medium">
      <el-form-item prop="emailDomain">
        <el-input v-model="ruleForm.emailDomain"></el-input>
        <el-button @click.prevent="addBlackList('ruleForm')" type="primary">{{$t("wm_lang_html_b58c75")}}</el-button>
        <el-button @click.prevent="viewBlackList({limit: 10, page: 1})" type="primary">{{$t("wm_lang_html_bee912")}}</el-button>
        <span>{{$t("wm_lang_html_614fc6")}}name@example.com{{$t("wm_lang_html_a71852")}}@example.com</span>
      </el-form-item>
      <!-- 表格 -->
      <el-form-item>
      <el-table
        size="medium"
        :data="tableData"
        ref="blackListTable"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="45">
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_2c35d9')">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.blackAddr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$i18n.t('wm_lang_2b6bc0')"
          width="160">
          <template slot-scope="scope">
            <el-link type="danger" :underline="false" @click="batchDelete('single',scope.row.blackAddr)">{{$t("wm_lang_html_2f4aad")}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      </el-form-item>
      <div class="page_block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
      <el-form-item>
        <el-button type="primary" @click="batchDelete('batch',[])">{{$t("wm_lang_html_2f4aad")}}</el-button>
        <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_625fb2")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import storeLocal from 'store';
export default {
  name: 'blacklist',
  data () {
    let emailDomainVerify = (rule, value, callback) => {
      if(this.ruleForm.emailDomain) {
        let regEmail=/^[a-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/;
        let regDomain = /^@[\w-]+(\.[\w-]+)+$/;
        if(!regEmail.test(this.ruleForm.emailDomain) && !regDomain.test(this.ruleForm.emailDomain)){
          callback(new Error(this.$i18n.t('wm_lang_f41cf0')));
        } else {
          callback();
        }
      }
    }
    return {
      currentPage: 1,
      pageSize: 0,
      total: 0,
      // 表格
      tableData: [],
      // 表单
      ruleForm: {
        emailDomain: ''
      },
      rules: {
        emailDomain: [
          { max: 256, message: this.$i18n.t('wm_lang_a652de'), trigger: 'blur' },
          { validator: emailDomainVerify, trigger: ['blur'] }
        ]
      }
    }
  },
  mounted() {
    const configSetting = storeLocal.get('Pwm-configSetting');
    this.rules.emailDomain[0].max = configSetting.globalConfig.fieldLengthLimit.blackListLimit.blackAddr;
    console.log(this.rules)
    this.viewBlackList({limit: 10, page: 1});
  },
  methods: {
    // 表单
    addBlackList(formName) {
      if(this.ruleForm.emailDomain === '') {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_e4a3b5')
        });
        return;
      }
      let regEmail=/^[a-z0-9]+([-_.]\w+)*@[\w-]+(\.[\w-]+)+$/;
      let regDomain = /^@[\w-]+(\.[\w-]+)+$/;
      if(!regEmail.test(this.ruleForm.emailDomain) && !regDomain.test(this.ruleForm.emailDomain)){
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_dc9dae')
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.Blacklist.addBlacklistAddrParamBuilder();
            pm.blackAddr = self.ruleForm.emailDomain;
            // pm.blackAddrMatchType = 1; // //不用前端传后端写
            api.Blacklist.addBlacklistAddr(pm, function (res) {
              if(res.data.code === 0) {
                console.log(res.data);
                self.ruleForm.emailDomain = '';
                self.viewBlackList({limit: 10, page: 1});
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_3fdaea')
                })
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.viewBlackList({limit: 10, page: val});
    },
    viewBlackList(opts) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Blacklist.queryBlacklistBypageParamBuilder();
        pm.keyWords = self.ruleForm.emailDomain;
        pm.limit = opts.limit;
        pm.page = opts.page;
        api.Blacklist.queryBlacklistBypage(pm, function (res) {
          if(res.data.code === 0) {
            console.log(res.data)
            self.tableData = res.data.data.records;
            self.currentPage = res.data.data.current;
            self.total = res.data.data.total;
            self.pageSize = res.data.data.size;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    batchDelete(type, addr) {
      if(type !== 'single'){
        if(this.$refs.blackListTable.selection.length === 0) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_b1415d')
          })
          return;
        }
      }
      this.$confirm(this.$i18n.t('wm_lang_2a8140'), this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let blackAddr = [];
        if(type === 'single'){
          blackAddr.push(addr)
        } else {
          this.$refs.blackListTable.selection.forEach((item) => {
            blackAddr.push(item.blackAddr)
          })
        }
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Blacklist.batchDelBlackAddrsParamBuilder();
          pm.blackAddr = blackAddr;
          api.Blacklist.batchDelBlackAddrs(pm, function (res) {
            console.log(res)
            self.viewBlackList({limit: 10, page: 1});
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_0007d1')+'!'
            });
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.$refs.blackListTable.clearSelection();
      this.ruleForm.emailDomain = '';
      this.viewBlackList({limit: 10, page: 1});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .page_block{ text-align: right; margin:20px 0 0 0 }
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/blacklist.vue